/* Así funciona · Combo Baño: Estante, Esquinero y Dispensador (2249619)
   Todo sale de las fotos reales del combo (funciona/combo-bano-estante-esquinero-y-dispensador/alinear.py y hacer.py):
   1) el esquinero real se estira: su tapa real sube y el tubo real (su perfil cromado, estirado a lo largo) sale del
      otro, como un tubo telescópico;
   2) los 4 cepillos reales suben a sus ranuras del dispensador real (el MISMO dispensador de la foto de detalle,
      alineado; detrás de cada cepillo, el portacepillos real rehecho con sus propios píxeles de cada lado);
   3) el estante real sobre el sanitario: la cámara entra y aparece la foto del baño real con ese mismo estante
      (alineada punto por punto), así se ve puesto.
   Ficha: estante de 3 niveles sobre el sanitario, esquinero ajustable de 4 repisas, dispensador de crema dental con
   portacepillos; incluye 1 + 1 + 1. El panel negro del dispensador no se explica en la ficha: no se le da función. */
NHF.escena('combo-bano-estante-esquinero-y-dispensador', function (E) {
  const D = /*DATOS*/{"base":{"src":"fn-combo-bano-estante-esquinero-y-dispensador-base.webp","caja":[60,40,1480,1520]},"cepillos":[{"src":"fn-combo-bano-estante-esquinero-y-dispensador-cep1.webp","caja":[462.01,1147.4,35.72,275.34],"nombre":"Cepillo eléctrico blanco"},{"src":"fn-combo-bano-estante-esquinero-y-dispensador-cep2.webp","caja":[506.57,1147.8,31.31,272.53],"nombre":"Cepillo eléctrico rosado"},{"src":"fn-combo-bano-estante-esquinero-y-dispensador-cep3.webp","caja":[558.34,1149.41,22.08,211.12],"nombre":"Cepillo manual"},{"src":"fn-combo-bano-estante-esquinero-y-dispensador-cep4.webp","caja":[602.49,1149.41,20.87,211.12],"nombre":"Cepillo manual"}],"dispensador":[404,932,401,522],"tapa":{"src":"fn-combo-bano-estante-esquinero-y-dispensador-tapa.webp","caja":[1111,834,33,28]},"tubo":{"src":"fn-combo-bano-estante-esquinero-y-dispensador-tubo.webp","x":1117,"w":22,"y1":862},"tope":{"y0":840,"min":560},"amb":{"src":"fn-combo-bano-estante-esquinero-y-dispensador-amb.webp","caja":[101.71,49.89,915.04,915.04]},"estante":[360,160,400,760]}/*FIN*/;
  const VISTA = [80, 140, 1440, 1360], VISTA_M = [320, 150, 940, 1340];
  const S = E.lienzo({ w: 1600, h: 1560, vista: VISTA, vistaMovil: VISTA_M });
  const movil = () => window.innerWidth < 760;
  E.titulo('Arma tu [baño].', 'Estira el esquinero, cuelga los cepillos y pon el estante sobre el sanitario.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de fotos reales) ---------- */
  S.img(D.base.src, D.base.caja, { z: 1, alt: 'Combo de baño: estante sobre el sanitario, dispensador de crema dental con cepillos y esquinero' });
  const tubo = S.img(D.tubo.src, [D.tubo.x, D.tubo.y1, D.tubo.w, 0], { z: 3 });
  const tapa = S.img(D.tapa.src, D.tapa.caja, { z: 4 });
  const BAJA = 62;   // los cepillos empiezan un poco más abajo de su ranura
  const ceps = D.cepillos.map((c, i) => {
    const g = S.grupo(c.caja, { z: 20 + i });
    S.img(c.src, c.caja, { en: g, alt: c.nombre });
    g.style.filter = 'drop-shadow(0 10px 9px rgba(60,50,35,.16))';
    const cx = c.caja[2] / 2, ancho = 46;
    const agarre = E.el('span', 'cb-agarre nhf-toque');  // nhf-toque: el anillo de pista del motor
    agarre.style.cssText = 'position:absolute;left:' + (cx - ancho / 2) + 'px;top:0;width:' + ancho + 'px;height:' + c.caja[3] + 'px;pointer-events:auto;cursor:grab;border-radius:' + ancho + 'px';
    g.appendChild(agarre);
    const o = { c, g, agarre, i, puesto: false };
    o.arr = E.arrastrable(g, {
      eje: 'y', etiqueta: c.nombre + ': súbelo a su ranura',
      limites: [c.caja[0], c.caja[1], c.caja[0] + c.caja[2], c.caja[1] + c.caja[3] + BAJA],
      alEmpezar() { if (ST.paso !== 1 || o.puesto) return; g.style.filter = 'drop-shadow(0 16px 12px rgba(60,50,35,.22))'; },
      alSoltar(dest, pos) {
        g.style.filter = 'drop-shadow(0 10px 9px rgba(60,50,35,.16))';
        if (ST.paso !== 1 || o.puesto) { o.arr.mover(0, o.puesto ? 0 : BAJA, 300); return; }
        if (pos.dy < BAJA * 0.6 || Math.abs(pos.dy - BAJA) < 4) colgar(o); else o.arr.mover(0, BAJA, 300);
      },
      alTeclado() { colgar(o); }
    });
    g.style.pointerEvents = 'none';
    o.arr.mover(0, BAJA);
    return o;
  });
  const amb = S.img(D.amb.src, D.amb.caja, { z: 60, opacidad: 0, alt: 'El estante puesto sobre el sanitario en un baño' });
  amb.style.transition = 'opacity .9s ease';
  E.cargar([D.base.src, D.tapa.src, D.tubo.src].concat(D.cepillos.map(c => c.src))).then(() => { S.cargando(false); E.cargar([D.amb.src]); });

  /* ---------- estado y panel ---------- */
  const ST = { paso: 0, y: D.tope.y0, cuelgan: 0, ocupado: false };
  const PASOS = ['Estira el esquinero a tu altura', 'Cuelga los cepillos en el dispensador', 'Pon el estante sobre el sanitario'];
  E.pasos(PASOS); E.paso(0);
  const lect = E.lectura({ etiqueta: 'Tu baño' }); lect.poner('0', 'de 3 piezas');
  const bAuto = E.boton('Estíralo por mí', () => auto(), { icono: 'toca' });
  E.nota('Incluye 1 estante de 3 niveles para el sanitario, 1 esquinero ajustable de 4 repisas y 1 dispensador de crema dental con portacepillos.');

  /* ---------- 1) esquinero: la tapa sube y el tubo sale ---------- */
  const RANGO = D.tope.y0 - D.tope.min;
  const zona = S.toque([D.tubo.x - 60, D.tope.y0 - 100, D.tubo.w + 120, 200], { etiqueta: 'Esquinero: estíralo hacia arriba' });
  zona.style.touchAction = 'none'; zona.style.cursor = 'ns-resize'; zona.classList.add('is-pista');
  function ponerY(y) {
    ST.y = E.clamp(y, D.tope.min, D.tope.y0);
    const d = ST.y - D.tope.y0;
    tapa.style.transform = 'translate3d(0,' + d.toFixed(1) + 'px,0)';
    const top = ST.y + 20;  // el tubo empieza debajo de la tapa
    tubo.style.top = top.toFixed(1) + 'px';
    tubo.style.height = Math.max(0, D.tubo.y1 - top).toFixed(1) + 'px';
    zona.style.top = (ST.y - 100) + 'px';
  }
  ponerY(D.tope.y0);
  let ini = null, movido = 0;
  zona.addEventListener('pointerdown', e => {
    if (ST.paso !== 0 || ST.ocupado) return;
    try { zona.setPointerCapture(e.pointerId); } catch (x) {}
    const p = S.punto(e); ini = { y: p.y, y0: ST.y }; movido = 0; zona.classList.remove('is-pista'); S.el.classList.add('is-tocado');
  });
  zona.addEventListener('pointermove', e => {
    if (!ini) return;
    const p = S.punto(e), d = (p.y - ini.y) * 1.15;
    movido = Math.max(movido, Math.abs(d)); ponerY(ini.y0 + d);
  });
  const soltar = () => {
    if (!ini) return; ini = null;
    if (movido <= 8) return;
    if (D.tope.y0 - ST.y >= RANGO * 0.35) esquineroListo();
    else S.pista('Súbelo un poco más', 'mano');
  };
  zona.addEventListener('pointerup', soltar); zona.addEventListener('pointercancel', soltar);
  zona.addEventListener('click', () => { if (movido <= 8 && ST.paso === 0) estirarSolo(); });
  zona.addEventListener('keydown', e => { if (e.key === 'ArrowUp' && ST.paso === 0) { e.preventDefault(); ponerY(ST.y - 40); if (D.tope.y0 - ST.y >= RANGO * 0.35) esquineroListo(); } });
  async function estirarSolo() {
    if (ST.paso !== 0 || ST.ocupado) return;
    ST.ocupado = true; zona.classList.remove('is-pista');
    const y0 = ST.y;
    await E.animarP(1200, k => ponerY(E.lerp(y0, D.tope.min + RANGO * 0.08, k)), E.suave);
    ST.ocupado = false;
    esquineroListo();
  }
  function esquineroListo() {
    if (ST.paso !== 0) return;
    zona.style.pointerEvents = 'none'; zona.classList.remove('is-pista');
    E.sonido.clic(); E.vibrar(12);
    lect.poner('1', 'de 3 piezas');
    S.pista('El esquinero queda a tu altura', 'toca');
    setTimeout(() => irPaso(1), 1300);
  }

  /* ---------- 2) cepillos: suben a su ranura ---------- */
  function marcarCepillo() {
    const sig = ceps.find(o => !o.puesto);
    ceps.forEach(o => o.agarre.classList.toggle('is-pista', o === sig));
  }
  async function colgar(o) {
    if (ST.paso !== 1 || o.puesto) return;
    o.puesto = true; o.agarre.style.pointerEvents = 'none'; o.agarre.classList.remove('is-pista');
    o.arr.mover(0, 0, 260);
    await E.esperar(240);
    E.sonido.tono(1500 + o.i * 120, .05, .035); E.vibrar(8);
    ST.cuelgan++;
    if (ST.cuelgan >= 4) {
      lect.poner('2', 'de 3 piezas');
      S.pista('Tus cepillos, cada uno en su ranura', 'toca');
      setTimeout(() => irPaso(2), 1000);
    } else { S.pista('Sigue: sube otro cepillo', 'mano'); marcarCepillo(); }
  }

  /* ---------- 3) estante: así queda sobre el sanitario (la foto del baño real, alineada) ---------- */
  const zEst = S.toque(D.estante, { etiqueta: 'Estante: míralo sobre el sanitario', alTocar: () => estante() });
  zEst.style.pointerEvents = 'none';
  function cajaBano() {
    const v = movil() ? VISTA_M : VISTA, ar = v[2] / v[3], [ax, ay, aw] = D.amb.caja;
    return ar >= 1 ? [ax, ay + (aw - aw / ar) / 2, aw, aw / ar] : [ax + (aw - aw * ar) / 2, ay, aw * ar, aw];
  }
  async function estante() {
    if (ST.paso !== 2 || ST.ocupado) return;
    ST.ocupado = true; zEst.classList.remove('is-pista'); zEst.style.pointerEvents = 'none'; bAuto.hidden = true;
    S.pista(null);
    await S.camara(cajaBano(), 1300);
    amb.style.opacity = '1';
    E.sonido.tono(660, .2, .025);
    await E.esperar(900);
    lect.poner('3', 'de 3 piezas');
    E.paso(3);
    S.pista('Así queda el estante sobre el sanitario', 'toca');
    ST.ocupado = false; ST.paso = 3;
    E.listo('Tres piezas para ordenar todo el baño: el estante sobre el sanitario, el esquinero a tu altura y el dispensador con tus cepillos.', reiniciar);
  }

  /* ---------- pasos, cámara y botón ---------- */
  async function irPaso(n) {
    ST.paso = n; E.paso(n);
    if (n === 1) {
      bAuto.texto('Cuélgalos por mí'); bAuto.hidden = false;
      await S.camara(movil() ? [420, 930, 400, 530] : [300, 860, 620, 620], 1000);
      ceps.forEach(o => { o.g.style.pointerEvents = 'auto'; });
      S.pista('Sube cada cepillo a su ranura', 'mano'); marcarCepillo();
    } else if (n === 2) {
      ceps.forEach(o => o.agarre.classList.remove('is-pista'));
      bAuto.texto('Muéstramelo en un baño'); bAuto.hidden = false;
      await S.camara(null, 1000);
      zEst.style.pointerEvents = 'auto'; zEst.classList.add('is-pista');
      S.pista('Toca el estante del sanitario', 'toca');
    }
  }
  async function auto() {
    if (ST.ocupado) return;
    if (ST.paso === 0) estirarSolo();
    else if (ST.paso === 1) { bAuto.hidden = true; for (const o of ceps) { if (!o.puesto) { await colgar(o); await E.esperar(200); } } }
    else if (ST.paso === 2) estante();
  }
  async function reiniciar() {
    E.noListo();
    amb.style.opacity = '0';
    await S.camara(null, 900);
    ST.paso = 0; ST.cuelgan = 0; ST.ocupado = false;
    ceps.forEach(o => { o.puesto = false; o.agarre.style.pointerEvents = 'auto'; o.g.style.pointerEvents = 'none'; o.agarre.classList.remove('is-pista'); o.arr.mover(0, BAJA, 500); });
    const y0 = ST.y;
    await E.animarP(700, k => ponerY(E.lerp(y0, D.tope.y0, k)), E.suave);
    zona.style.pointerEvents = 'auto'; zona.classList.add('is-pista');
    zEst.style.pointerEvents = 'none'; zEst.classList.remove('is-pista');
    lect.poner('0', 'de 3 piezas'); bAuto.texto('Estíralo por mí'); bAuto.hidden = false;
    E.pasos(PASOS); E.paso(0);
    inicio();
  }
  function inicio() {
    S.pista('Arrastra hacia arriba la punta del esquinero', 'mano');
    if (movil()) S.camara([880, 380, 470, 900], 900);
  }
  E.alVer(() => setTimeout(() => { if (ST.paso === 0 && ST.y === D.tope.y0) inicio(); }, 400), 0.4);
  S.pista('Arrastra hacia arriba la punta del esquinero', 'mano');
});
